import Api from './api';

const UserService = {
    login: async (params) => {
        const response = await Api.post('/login', params);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('nivel', response.data.user["nivel"]);
        localStorage.setItem('nome', response.data.user["nome_fiscal"]);
        localStorage.setItem('token', response.data.token);
    },
    logout: () => {
        localStorage.removeItem('user', null)
        localStorage.removeItem('token', null)
        localStorage.removeItem('nome', null)
        localStorage.removeItem('nivel', null)
    }
}

export default UserService;
